import { lazy, Suspense } from "react";
import { Helmet } from "react-helmet-async";
import Header from "@/components/landing/Header";

const FeatureBento = lazy(() => import("@/components/landing/FeatureBento"));
const FeatureSpotlight = lazy(() => import("@/components/landing/FeatureSpotlight"));
const Footer = lazy(() => import("@/components/landing/Footer"));

const Features = () => {
  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>Features – PieFolio AI Portfolio Tracker</title>
        <meta
          name="description"
          content="Explore every PieFolio AI feature: Portfolio Health Score, AI analysis, dividend calendar, multi-account tracking, and Shariah screening (roadmap)."
        />
        <link rel="canonical" href="https://getpiefolio.com/features" />
        <link rel="alternate" type="text/markdown" href="https://getpiefolio.com/features.md" />
        <meta property="og:title" content="Features – PieFolio AI" />
        <meta
          property="og:description"
          content="Portfolio Health Score, AI analysis, dividend calendar and more — every feature of the PieFolio AI portfolio tracker."
        />
        <meta property="og:url" content="https://getpiefolio.com/features" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: [
              { "@type": "ListItem", position: 1, name: "Home", item: "https://getpiefolio.com/" },
              { "@type": "ListItem", position: 2, name: "Features", item: "https://getpiefolio.com/features" },
            ],
          })}
        </script>
      </Helmet>
      <Header />
      <main className="pt-24">
        <header className="container mx-auto px-6 lg:px-12 max-w-4xl text-center py-12">
          <h1 className="text-4xl lg:text-6xl font-extrabold tracking-tight mb-6">
            Every feature of <span className="text-gradient-sage">PieFolio AI</span>
          </h1>
          <p className="text-lg lg:text-xl text-muted-foreground">
            A complete portfolio tracker for everyday investors. Track every holding, get an AI-written
            analysis, see your Health Score, and never miss a dividend.
          </p>
        </header>
        <Suspense fallback={null}>
          <FeatureBento />
          <FeatureSpotlight />
          <Footer />
        </Suspense>
      </main>
    </div>
  );
};

export default Features;
